import { FC } from 'react';
import { Link } from '@zoopla-eng/zds-components/link';
import { triggerTracking } from '@zoopla/tracking';
import { Node } from '@contentful/rich-text-types';
import { renderContentWithMarks } from '../Hyperlink';

type Props = {
    node: Node;
};

const EntryHyperlink: FC<Props> = ({ node }) => {
    const { slug, category } = node?.data?.target?.fields || {};
    const articleCategory = category.fields?.slug;
    const entryLinkHref = `/discover/${articleCategory}/${slug}/`;

    return (
        <Link
            href={`${entryLinkHref}`}
            onClick={function () {
                triggerTracking({
                    event: 'GAEvent',
                    eventCategory: 'discover',
                    eventAction: 'clickthrough',
                    eventLabel: `body link,${entryLinkHref}`
                });
            }}
        >
            {renderContentWithMarks(node)}
        </Link>
    );
};

export default EntryHyperlink;
